import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const usePageTracking = ({
    pageTitle
}) => {
    const location = useLocation();

    useEffect(() => {
        // Track GA quando cambia la location
        window.gtag('config', 'G-2TB06FZ19X', {
            page_title: `${pageTitle} - TicinoWild`,
            page_location: window.location.href,
            page_path: location.pathname
        })
    }, [location, pageTitle])

    return { pageTitle }
}
export default usePageTracking;